import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import importer from "common/importer";

const { reducer: PublicContentReducer } = importer("Stores/PublicContent/Reducers", null);
const { reducer: AppointmentsReducer } = importer("Stores/Appointments/Reducers", null);
const { reducer: AuthCustomReducer } = importer("Stores/AuthCustom/Reducers", null);
const { reducer: CentersReducer } = importer("Stores/Centers/Reducers", null);
const { reducer: UsersReducer } = importer("Stores/Users/Reducers", null);
const { reducer: DonorsReducer } = importer("Stores/Donors/Reducers", null);
const { reducer: WirecardReducer } = importer("Stores/Wirecard/Reducers", null);
const { reducer: PaymentsReducer } = importer("Stores/Payments/Reducers", null);
const { reducer: LoyaltyDetailsReducer } = importer("Stores/Loyalty/Reducers", null);
const { reducer: PreviewReducer } = importer("Stores/Preview/Reducers", null);
const { reducer: ChatbotReducer } = importer("Stores/Chatbot/Reducers", null);

const appointmentsPersistConfig = {
  key: "appointments",
  storage: storage,
  blacklist: [
    "scheduleAppointmentLoading",
    "scheduleAppointmentFailure",
    "scheduleAppointmentSuccess",
    "scheduleQuickAppointmentFailure",
    "getAllAppointmentsLoading",
    "getAllAppointmentsSuccess",
    "getAllAppointmentsFailure",
    "getAppointmentLoading",
    "getAppointmentFailure",
    "rescheduleAppointmentSuccess",
    "rescheduleAppointmentFailure",
    "rescheduleAppointmentLoading",
    "cancelAppointmentSuccess",
    "cancelAppointmentFailure",
    "getUpcomingAppointmentsFailure",
    "validateAppointmentFailure",
    "createNewAppointmentSuccess",
    "createNewAppointmentLoading",
    "createNewAppointmentFailure",
    "getBookedSlotsFailure",
    "getAvailableSlotsFailure",
    "scheduleQuickAppointmentLoading",
    "scheduleQuickAppointmentSuccess",
    "updateGiftCardPreferenceSuccess",
    "updateGiftCardPreferenceLoading",
    "updateGiftCardPreferenceFailure",
    "authenticateMfaCodeSuccess",
    "authenticateMfaCodeFailure"
  ]
};
const loyaltyDetailsPersistConfig = {
  key: "loyalty",
  storage: storage,
  blacklist: [
    "getLoyaltyDetailsFailure",
    "getLoyaltyActivityFailure",
    "redeemRewardsSuccess",
    "redeemRewardsFailure",
    "redeemRewardsStatusCheckSuccess",
    "redeemRewardsStatusCheckFailure",
    "activeLoyaltyPromotionsSuccess",
    "activeLoyaltyPromotionsFailure",
    "getLoyaltyGameDataLoading",
    "getLoyaltyGameDataSuccess",
    "getLoyaltyGameDataFailure",
    "updateLoyaltyGameDataLoading",
    "updateLoyaltyGameDataSuccess",
    "updateLoyaltyGameDataFailure"
  ]
};

const authCustomPersistConfig = {
  key: "authCustom",
  storage: storage,
  blacklist: [
    "loginFailure",
    "loginAuthFailure",
    "loginHerokuFailure",
    "loginTokenExchangeFailure",
    "registerFailure",
    "logoutFailure",
    "getSessionFailure",
    "getSessionUserFailure",
    "changePasswordFailure",
    "changeRecoveryQuestionFailure",
    "forgotPasswordFailure",
    "sessionRefreshFailure"
  ]
};

const centersPersistConfig = {
  key: "centers",
  storage: storage,
  blacklist: [
    "getAllCentersFailure",
    "getAppointmentCenterFailure",
    "searchCentersFailure",
    "getDonorCentersAllFailure",
    "registerGetCentersFailure",
    "getAppointmentSlotFailure",
    "addAppointmentSlotFailure",
    "addAppointmentSlotSuccess",
    "registerGetCentersSuccess",
    "getSlotsForDonorFailure",
    "getAppointmentReportFailure",
    "downloadReportFailure",
    "saveSlotConfigSuccess",
    "saveSlotConfigError",
    "saveCenterSlotConfigFailure",
    "getSlotsForAppointmentTypeSuccess",
    "getSlotsForAppointmentTypeLoading",
    "getSlotsForAppointmentTypeFailure",
    "getZipcodeSearchCentersSuccess",
    "getZipcodeSearchCentersLoading",
    "getZipcodeSearchCentersFailure",
    "getCenterInfoFailure",
    "createApplicationUserFailure",
    "createApplicationUserSuccess",
    "createApplicationUser",
    "getApplicationUserDetailsLoading",
    "getApplicationUserDetailsSuccess",
    "getApplicationUserDetailsFailure",
    "editApplicationUserFailure",
    "editApplicationUserSuccess",
    "editApplicationUser",
    "removeUserCenterAccessFailure",
    "removeUserCenterAccessSuccess",
    "removeUserCenterAccess",
    "updateUserDefaultCenterFailure",
    "updateUserDefaultCenterSuccess",
    "updateUserDefaultCenter",
    "removeUserPortalAccess",
    "removeUserPortalAccessFailure",
    "removeUserPortalAccessSuccess",
    "addUserCenterAccess",
    "addUserCenterAccessFailure",
    "addUserCenterAccessSuccess",
    "updateFavoriteCenterFailure",
    "updateFavoriteCenterSuccess"
  ]
};

const usersPersistConfig = {
  key: "users",
  storage: storage,
  blacklist: [
    "loginLoading",
    "loginSuccess",
    "loginFailure",
    "loginAuthFailure",
    "loginHerokuFailure",
    "loginTokenExchangeFailure",
    "loginWithTokenSuccess",
    "loginWithTokenFailure",
    "loginWithTokenLoading",
    "registerFailure",
    "logoutFailure",
    "getSessionFailure",
    "getSessionUserFailure",
    "sessionRefreshFailure",
    "verifyOktaAccountSuccess",
    "verifyOktaAccountLoading",
    "verifyOktaAccountFailure",
    "verifyEmailFailure",
    "resetPasswordFailure",
    "logoutTimeout",
    "emailLoginLoading",
    "emailLoginSuccess",
    "emailLoginFailure",
    "resetPassword2Success",
    "resetPassword2Failure",
    "resetPassword3Loading",
    "resetPassword3Success",
    "resetPassword3Failure",
    "resetPassword3Failure",
    "enrollMfaFailure",
    "enrollMfaSuccess",
    "resendEnrollMfaCodeFailure",
    "resendEnrollMfaCodeSuccess",
    "verifyMfaCodeFailure",
    "verifyMfaCodeSuccess"
  ]
};

const donorsPersistConfig = {
  key: "donors",
  storage: storage,
  blacklist: [
    "getAllDonorsFailure",
    "getDonorsFailure",
    "searchForDonorSuccess",
    "searchForDonorFailure",
    "registerDonorSuccess",
    "registerDonorFailure",
    "registerGetDonorProfileSuccess",
    "registerGetDonorProfileFailure",
    "inquiryDonorFailure",
    "getDonorsPreferencesFailure",
    "updateDonorsPreferencesFailure"
  ]
};

const wirecardPersistConfig = {
  key: "wirecard",
  storage: storage,
  blacklist: ["getWirecardInfoFailure"]
};

const paymentsPersistConfig = {
  key: "payments",
  storage: storage,
  blacklist: ["getPaymentsCouponProgressFailure", "applyPaymentPromoCodeFailure"]
};

export default {
  publicContent: PublicContentReducer,
  appointments: persistReducer(appointmentsPersistConfig, AppointmentsReducer),
  authCustom: persistReducer(authCustomPersistConfig, AuthCustomReducer),
  centers: persistReducer(centersPersistConfig, CentersReducer),
  users: persistReducer(usersPersistConfig, UsersReducer),
  donors: persistReducer(donorsPersistConfig, DonorsReducer),
  wirecard: persistReducer(wirecardPersistConfig, WirecardReducer),
  payments: persistReducer(paymentsPersistConfig, PaymentsReducer),
  loyalty: persistReducer(loyaltyDetailsPersistConfig, LoyaltyDetailsReducer),
  preview: PreviewReducer,
  chatbot: ChatbotReducer
};
